{
    "EN": {
    "registrationFormHeading": "Welcome to IDP!",
    "selectMultiple": "Choose one or more",
    "phoneNumberInvalidError1": "Please check the number – it should have ",
    "phoneNumberInvalidError2": " digits with no spaces",
    "numberOfQuestionsText": "We value your time. This short set of questions will help us assist you better!",
    "buttonValue": "Confirm"
  },
  "VN_VIE": {
    "registrationFormHeading": "Chào mừng đến với IDP!",
    "selectMultiple": "Chọn một hoặc nhiều",
    "phoneNumberInvalidError1": "Vui lòng kiểm tra số điện thoại - bạn cần nhập ",
    "phoneNumberInvalidError2": " chữ số không có dấu cách",
    "numberOfQuestionsText": "Hãy dành chút thời gian để trả lời một vài câu hỏi. Chỉ mất khoảng 3 phút để hoàn thành.",
    "buttonValue": "Xác nhận"
  },
 "KH_KHM": {
    "registrationFormHeading": "សូមស្វាគមន៍មកកាន់ IDP!",
    "selectMultiple": "ជ្រើសរើសមួយ ឬច្រើន",
    "phoneNumberInvalidError1": "សូមផ្ទៀងលេខទូរស័ព្ទរបស់អ្នក - លេខទូរស័ព្ទរបស់អ្នកគួរតែមានតួរលេខសរុប",
    "phoneNumberInvalidError2": " ខ្ទង់",
    "numberOfQuestionsText": "សូមចំណាយពេលបន្តិចដើម្បីឆ្លើយសំណួរមួយចំនួន។ វានឹងចំណាយពេលប្រហែល 3 នាទីដើម្បីបញ្ចប់។",
    "buttonValue": "បញ្ជាក់"
  },
  "ID_IND": {
    "registrationFormHeading": "Selamat datang di IDP!",
    "selectMultiple": "Pilih satu atau lebih",
    "phoneNumberInvalidError1": "Periksa nomor Anda - Nomor harus terdiri dari ",
    "phoneNumberInvalidError2": " digit tanpa spasi",
    "numberOfQuestionsText": "Mari luangkan waktu sejenak untuk menjawab beberapa pertanyaan. Hanya butuh waktu sekitar 3 menit untuk menyelesaikannya.",
    "buttonValue": "Konfirmasi"
  },
  "TH_THA": {
    "registrationFormHeading": "ยินดีต้อนรับสู่ IDP!",
    "selectMultiple": "เลือกได้ มากกว่า 1 คำตอบ",
    "phoneNumberInvalidError1": "กรุุณาตรวจสอบเบอร์โทรศัพท์ให้ครบ ",
    "phoneNumberInvalidError2": " หลัก โดยไม่เว้นช่องว่าง",
    "numberOfQuestionsText": "สละเวลาสักครู่เพื่อตอบคำถามสั้น ๆ ใช้เวลาเพียงประมาณ 3 นาทีเท่านั้น",
    "buttonValue": "ยืนยัน"
  },
  "SA_ARA": {
    "registrationFormHeading": "مرحباً بك في IDP!",
    "selectMultiple": "اختر واحداً أو أكثر",
    "phoneNumberInvalidError1": " ج التأكد من الرقم - يجب أن يتكون من  ",
    "phoneNumberInvalidError2": " أرقام بدون مسافات",
    "numberOfQuestionsText": "خصص لحظة للإجابة على بعض الأسئلة. سيستغرق الأمر حوالي 3 دقائق لإكماله.",
    "buttonValue": "تأكيد"
  },
  "KR_KOR": {
    "registrationFormHeading": "IDP에 오신 것을 환영합니다!",
    "selectMultiple": "하나 또는 여러 개를 선택해 주세요",
    "phoneNumberInvalidError1": "-'없이 핸드폰번호만 입력해 주세요.",
    "phoneNumberInvalidError2": "",
    "numberOfQuestionsText": "몇 가지 질문에 답해 주세요.  3분 정도 걸립니다.",
    "buttonValue": "확인"
  },
  "TR_TUR": {
    "registrationFormHeading": "IDP'ye Hoş Geldiniz!",
    "selectMultiple": "Bir veya daha fazla seçin",
    "phoneNumberInvalidError1": "Lütfen telefon numaranızı kontrol ediniz. Başında sıfır olacak şekilde boşluk bırakmadan giriniz",
    "phoneNumberInvalidError2": "",
    "numberOfQuestionsText": "Birkaç soruyu yanıtlamak için bir dakikanızı ayırın. Tamamlanması yaklaşık 3 dakika sürecektir.",
    "buttonValue": "Onayla"
  },
  "TW_CHI": {
    "registrationFormHeading": "歡迎來到 IDP ！",
    "selectMultiple": "選擇一個或多個",
    "phoneNumberInvalidError1": "請檢查數字-它應該是 ",
    "phoneNumberInvalidError2": " 位數字，沒有空格",
    "numberOfQuestionsText": "請花點時間回答幾個問題，大約需要 3 分鐘。",
    "buttonValue": "確認"
  },
  "HK_CHI": {
    "registrationFormHeading": "歡迎來到 IDP 教育！",
    "selectMultiple": "選擇一個或多個",
    "phoneNumberInvalidError1": "請檢查數字-它應該是 ",
    "phoneNumberInvalidError2": " 位數字，沒有空格L̥",
    "numberOfQuestionsText": "請花點時間回答幾個問題，大約需要 3 分鐘。",
    "buttonValue": "確認"
  },
  "HK_ZK": {
    "registrationFormHeading": "欢迎来到 IDP 教育！",
    "selectMultiple": "选择一个或多个",
    "phoneNumberInvalidError1": "请检查数字-它应该是 ",
    "phoneNumberInvalidError2": " 位数字，没有空格",
    "numberOfQuestionsText": "请花点时间回答几个问题，大约需要 3 分钟。",
    "buttonValue": "确认"
  },
  "IR_FAS": {
    "registrationFormHeading": "به IDP خوش آمدید!",
    "selectMultiple": "یک یا چند مورد انتخاب کنید",
    "phoneNumberInvalidError1": "لطفاً شماره را بررسی کنید - باید دارای ",
    "phoneNumberInvalidError2": " رقم بدون فاصله باشد",
    "numberOfQuestionsText": "لطفاً لحظه‌ای وقت بگذارید و به چند سؤال پاسخ دهید. حدود ۳ دقیقه طول می‌کشد.",
    "buttonValue": "تأیید"
  },
  "CN_CHI": {
    "registrationFormHeading": "歡迎來到 IDP 教育！",
    "selectMultiple": "選擇一個或多個",
    "phoneNumberInvalidError1": "請檢查數字-它應該是 ",
    "phoneNumberInvalidError2": " 位數字，沒有空格L̥",
    "numberOfQuestionsText": "請花點時間回答幾個問題，大約需要 3 分鐘。",
    "buttonValue": "確認"
  },
  "CN_ZK": {
    "registrationFormHeading": "欢迎来到 IDP 教育！",
    "selectMultiple": "选择一个或多个",
    "phoneNumberInvalidError1": "请检查数字-它应该是 ",
    "phoneNumberInvalidError2": " 位数字，没有空格",
    "numberOfQuestionsText": "请花点时间回答几个问题，大约需要 3 分钟。",
    "buttonValue": "确认"
  }
}